import { useEffect, useState } from "react";
import {
  addNotification,
  setDrawStatus,
} from "../../state/draw-details/reducer";
import {
  successEnteringDraw,
  alertAlreadyInDraw,
} from "../../constants/notifications";
import { useDrawDetails } from "../../context/draw-details";
import {
  enterDrawWeb,
  enterDrawAppFlow,
  setAndLogin,
  isAuthenticated,
  getVariantSelected,
  isNativeApp,
  getNativeAppsAlreadyEnteredVid,
  errorNotification,
} from "./utilities";
import styles from "./styles";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import { EnterFormBody } from "../enter-form-body";

export const EnterForm = () => {
  const [state, dispatch] = useDrawDetails();
  const {
    loading,
    variants,
    drawDetails: { dateDrawUtc },
    content: { drawId, drawSlug, termsAndConditions, premierDeliveryPageLink },
  } = state;

  const [variantSelected, setVariantSelected] = useState(
    getVariantSelected(drawId)
  );
  const [enteringDraw, setEnteringDraw] = useState(() => !!variantSelected);

  const [nativeAppsAlreadyEnteredVariantId] = useState(
    getNativeAppsAlreadyEnteredVid()
  );

  const onVariantSelect = (event) => {
    setVariantSelected(event.target.value);
  };

  const onButtonClick = () => {
    setEnteringDraw(true);
  };

  useEffect(() => {
    if (variantSelected && nativeAppsAlreadyEnteredVariantId) {
      dispatch(
        addNotification(
          alertAlreadyInDraw(dateDrawUtc, termsAndConditions?.linkUrl)
        )
      );
      trackPageEvent({
        content: {
          layout: "limited-drops-message",
          message: "you already entered",
        },
      });
    }
  }, [
    dispatch,
    dateDrawUtc,
    variantSelected,
    nativeAppsAlreadyEnteredVariantId,
  ]);

  useEffect(() => {
    const enterDrawWebFlow = async () => {
      const authenticated = await isAuthenticated();

      if (authenticated) {
        try {
          await enterDrawWeb(drawId, variantSelected);
          setEnteringDraw(false);
          dispatch(
            addNotification(
              successEnteringDraw(dateDrawUtc, termsAndConditions?.linkUrl)
            )
          );
          dispatch(setDrawStatus("entered"));
          trackPageEvent({
            content: {
              layout: "limited-drops-message",
              message: "you successfully entered",
            },
          });
        } catch (error) {
          setEnteringDraw(false);
          errorNotification(
            error,
            dispatch,
            dateDrawUtc,
            termsAndConditions?.linkUrl,
            premierDeliveryPageLink
          );
        }
      } else {
        try {
          await setAndLogin(drawId, variantSelected);
        } catch (error) {
          errorNotification(error, dispatch);
        }
      }
    };

    if (variants.length === 1) {
      setVariantSelected(variants[0].value);
    }

    if (enteringDraw) {
      if (isNativeApp()) {
        if (!nativeAppsAlreadyEnteredVariantId) {
          enterDrawAppFlow(drawSlug, drawId, variantSelected);
        }
      } else {
        enterDrawWebFlow();
      }
    }
  }, [
    variantSelected,
    enteringDraw,
    dispatch,
    drawId,
    dateDrawUtc,
    drawSlug,
    nativeAppsAlreadyEnteredVariantId,
  ]);

  return (
    <div className={styles.wrapper}>
      {!loading && (
        <>
          <EnterFormBody
            variants={variants}
            onVariantSelect={onVariantSelect}
            variantSelected={variantSelected}
            enteringDraw={enteringDraw}
            onButtonClick={onButtonClick}
            nativeAppsAlreadyEnteredVariantId={
              nativeAppsAlreadyEnteredVariantId
            }
          ></EnterFormBody>
        </>
      )}
    </div>
  );
};
